/**
 * Mirrors VerificationTaskPriority in the backend (Domain/Enums/CommonEnums.cs).
 * Serialized by name via the API's global JsonStringEnumConverter.
 */
export enum VerificationTaskPriority {
  Low = 'Low',
  Normal = 'Normal',
  High = 'High',
  Urgent = 'Urgent'
}
